import { observer } from 'mobx-react-lite';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { gameStore } from '../../stores/GameStore';
import { sharedStore } from '../../stores/SharedStore';
import { executableUndoableMapEditorSetTileInteractionTriggerLabel, executableUndoableMapEditorSetTileInteractionTriggerStatus, executableUndoableMapEditorSetTileModuleGateStatus } from '../../stores/undo/operation/MapEditorSetTileInteractionTriggerData';
import { MenuCard } from '../menu/MenuCard';
import { ElementTitleDisplay, LabelInput } from './DynamicMapElementPropertiesSharedElements';
export const InteractionTriggerTilePropertiesEditor = observer(({
  tileData,
  currentMapStore
}) => {
  var _sharedStore$getTileA;

  const {
    t
  } = useTranslation();
  if (!tileData.interactionTriggerData) return null;
  const name = (_sharedStore$getTileA = sharedStore.getTileAsset(tileData.tileAssetId)) === null || _sharedStore$getTileA === void 0 ? void 0 : _sharedStore$getTileA.localizedName.get(gameStore.languageKey);
  return /*#__PURE__*/React.createElement(MenuCard, null, /*#__PURE__*/React.createElement(ElementTitleDisplay, {
    element: tileData,
    elementTypeKey:
    /*t*/
    "editor.editor_display_type_tile_decoration",
    name: name
  }), /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    colSpan: 2
  }, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    checked: true,
    onChange: () => executableUndoableMapEditorSetTileInteractionTriggerStatus(currentMapStore, tileData, false)
  }), "\xA0", t("editor.element_is_interaction_trigger")))), !currentMapStore.isCurrentMapPartOfTheModule && /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    colSpan: 2
  }, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    checked: tileData.interactionTriggerData.isModuleGate,
    onChange: () => executableUndoableMapEditorSetTileModuleGateStatus(currentMapStore, tileData, !tileData.interactionTriggerData.isModuleGate)
  }), "\xA0", t("editor.element_is_module_gate_interaction_trigger")))), /*#__PURE__*/React.createElement(LabelInput, {
    element: tileData.interactionTriggerData,
    allElements: currentMapStore.currentMap.interactionTriggerTiles.map(tile => tile.interactionTriggerData),
    alreadyUsedWarningLabelKey:
    /*t*/
    "editor.warning_tile_interaction_trigger_label_already_used",
    onChange: value => executableUndoableMapEditorSetTileInteractionTriggerLabel(currentMapStore, tileData, value)
  }))));
});